import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getBlockTypesForDeviation, getHighestPriorityBlockReasonForDeviation } from '../../Moderation/redux/selectors';
import { BlockReasons } from '../../Moderation/redux/types';
const matureReasons = [
    BlockReasons.MatureAge,
    BlockReasons.MatureFilter,
    BlockReasons.Nsfg
];
export function useDeviationMatureFilter(deviation) {
    var _ref;
    const blockReasons = useSelector((state)=>(_ref = deviation && getBlockTypesForDeviation(state, deviation)) !== null && _ref !== void 0 ? _ref : []);
    const displayReason = useSelector((state)=>deviation && getHighestPriorityBlockReasonForDeviation(state, deviation));
    const [matureFilterDisabled, setMatureFilterDisabled] = useState(false);
    // reset mature filter override when deviation changes
    const { deviationId =0  } = deviation || {};
    useEffect(()=>{
        setMatureFilterDisabled(false);
    }, [
        deviationId
    ]);
    const hasNonOverridableBlockReasons = blockReasons.some((reason)=>!matureReasons.includes(reason));
    const hasOverridableMatureBlockReasons = blockReasons.some((reason)=>matureReasons.includes(reason));
    const props = useMemo(()=>({
            showBlocked: hasNonOverridableBlockReasons || hasOverridableMatureBlockReasons && !matureFilterDisabled,
            overrideMatureFilter: ()=>setMatureFilterDisabled(true),
            displayReason
        }), [
        hasNonOverridableBlockReasons,
        hasOverridableMatureBlockReasons,
        matureFilterDisabled,
        displayReason
    ]);
    return props;
}
